import * as components from './assets/css/themes/components';
import * as customComponents from './assets/css/themes/custom-components';

export default defineAppConfig({
    ui: {
        // Befor adding check if this icon place realy exist in app.config.mjs at .nuxt folder
        // default icons. If unset will lead to usage of 'lucide:*', what will lead to warning - '[Icon] failed to load icon `lucide:*`'
        icons: {
            check: 'br-icon:check-mark',
            chevronDown: 'br-icon:chevron-down',
            chevronUp: 'br-icon:chevron-up',
            loading: 'br-icon:loader',
            close: 'br-icon:x',
            search: 'br-icon:search',
            chevronLeft: 'br-icon:chevron-left',
            chevronRight: 'br-icon:chevron-right',
            chevronDoubleLeft: 'br-icon:chevron-group-left',
            chevronDoubleRight: 'br-icon:chevron-group-right',
            nextMonth: 'br-icon:chevron-right',
            nextYear: 'br-icon:chevron-group-right',
            prevYear: 'br-icon:chevron-group-left',
            prevMonth: 'br-icon:chevron-left'
        },
        ...components,
        ...customComponents
    }
});
